//import * as moment from 'moment-timezone';

export function pushAnalyticsData( productCode, eventName, productsInList = [] ) {
	/**
	 * @see https://colibrigroup.atlassian.net/browse/ECOM-930
	 */
	if ( !productCode || !window?.colibri?.analytics || !window.colibri.index?.products ) {
		console.log( 'Could not push to analytics', productCode, window.colibri.analytics );
		return;
	}

	let listStr = '';

	if ( productCode === 'list' ) {
		if ( !productsInList.length ) {
			return;
		}

		listStr = getListStr( productsInList[0] );
		let itemsGA4 = [];

		for ( let i = 0; i < productsInList.length; i++ ) {
			const product = getProductAttributes( productsInList[i] );

			if ( !product ){
				continue;
			}

			let productGA4 = {
				item_id: productsInList[i],
				item_name: product.name,
				index: i,
				item_brand: product.brand,
				item_list_name: listStr,
				item_variant: product.variant,
				price: product.price,
				quantity: 1,
			};

			if ( product.discount ) {
				productGA4.discount = product.discount;
			}

			itemsGA4.push( productGA4 );
		}

		window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
		window.dataLayer.push({
			event: eventName,
			ecommerce: {
				item_list_name: listStr,
				items: itemsGA4,
			},
		});

	} else {

		listStr = getListStr( productCode );

		const product = getProductAttributes( productCode );

		if ( !product ) {
			return;
		}

		let productGA4 = {
			item_id: productCode,
			item_name: product.name,
			item_brand: product.brand,
			item_list_name: listStr,
			item_variant: product.variant,
			price: product.price,
			quantity: 1,
		};

		if (product.discount) {
			productGA4.discount = product.discount;
		}

		window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
		window.dataLayer.push({
			event: eventName,
			ecommerce: {
				currency: "USD",
				value: product.price,
				items: [productGA4],
			},
		});
	}
}

function getListStr( productCode ) {
	let list = [];
	let heroTitle = jQuery( '[data-module="hero"] h1' ).text() || jQuery( '.hero-block h1' ).text() || jQuery( 'h1' ).text() || 'N/A';

	list.push(heroTitle);

	let $addToCart = jQuery( '.product-list-container .add-to-cart-container[data-product-code="' + productCode + '"]' ).first();

	if ( $addToCart.length === 0 ) {
		$addToCart = jQuery( '.course-list .add-to-cart-container[data-product-code="' + productCode + '"]' ).first();
	}

	const $list = $addToCart.closest( '.product-list-container' );

	if (!!$list.length) {
		const sectionTitle = $list.find( '.section-details > *:first-child' ).text();

		if ( sectionTitle ) {
			list.push( sectionTitle );
		}
	} else {
		const $tabsBlock = $addToCart.closest( '.wp-block-colibri-tabs' );
		if ( $tabsBlock && $tabsBlock.length > 0 ) {
			list.push( 'Packages' );

			const tabsBlockTitle = $tabsBlock.closest( 'h2' ).text();

			if ( tabsBlockTitle ) {
				list.push( tabsBlockTitle );
			}

			const currentTabsTitle = jQuery( '[aria-selected="true"].wp-block-colibri-tabs__tab .wp-block-colibri-tabs__tab__text-label', $tabsBlock ).text();

			if ( currentTabsTitle ) {
				list.push( currentTabsTitle );
			}
		}
	}

	return list.join( ' - ' );
}

function getProductAttributes( productCode ) {
	const details = Object.values(window.colibri.index.products).find(p => p.first_variant.product_code === productCode);

	if ( !details ) {
		console.log('Could not find product details for', productCode);
		return null;
	}

	const productId = details.product_id;
	const product = window.colibri.analytics.find(p => p.id == productId);

	if ( !product ) {
		console.log('Could not resolve product from product id', productId);
		return null;
	}

	product.quantity = 1;
	product.variant = productCode.split('-')[2];
	product.price = Number(details.first_variant.price);
	product.discount = 0;

	if ( details?.first_variant?.discounted_price ) {
		const discountedPrice = Number( details.first_variant.discounted_price );

		if ( discountedPrice > 0 ) {
			product.discount = product.price - discountedPrice;
			product.discount = Math.round( product.discount * 10 ) / 10;
			product.price = discountedPrice;
		}
	}

	return product;
}

export function formatTime( timestamp, format = 'MM/DD/YYYY h:mmA z' ) {
	if ( typeof window.moment !== 'undefined' && typeof window.moment.tz !== 'undefined') {
		return window.moment.tz( timestamp * 1000, moment.tz.guess() ).format( format )
	}
	return timestamp;
}

function updateTimestamps( elements ) {
	jQuery( elements ).each( function( idx, e ) {
		const $el = jQuery( e );
		let time = $el.data( 'timestamp' );
		if ( !time ) {
			return true;
		}

		let format = '';
		if ( $el.is( '.has-day' ) ) {
			format += 'MM/DD/YYYY';
		}
		if ( $el.is( '.has-hours' ) ) {
			format += format
					  ? ' '
					  : '';
			format += 'h:mmA';
		}
		if ( $el.is( '.has-tz' ) ) {
			format += format
					  ? ' '
					  : '';
			format += 'z';
		}

		$el.text( formatTime( time, format ) );
	} );
}

/**
 * Update all times on page that are wrapped in an element with `.js-timestamp` class
 *
 * @param {null|string|object} container
 */
export function maybeUpdateTimezones( container = null ) {

	let elements = container
	   ? ( typeof container === 'string'
		   ? jQuery( container + ' .js-timestamp' )
		   : container.find( '.js-timestamp' ) )
	   : jQuery( '.js-timestamp' ); //search globally

	if ( !elements.length ) {
		return;
	}

	updateTimestamps( elements );
}

export function maybeInitMapLinks() {

	const $mapModalLinks = jQuery( '.js-open-map-modal' );

	if ( !$mapModalLinks.length ) {
		return;
	}

	jQuery.getScript( '/wp-content/mu-plugins/wp-common-plugin/src/Technical/Maps/maps-loader.js?ver=' + window.colibri.version );

}
